import {React , useRef,useContext} from 'react'
import './login.css'
import {loginCall} from '../../apiCalls'
import {AuthContext} from '../../context/AuthContext'
import {Link,useNavigate} from 'react-router-dom'


export default function Login() {
  const email = useRef();
  const password = useRef();
  const {user ,isFetching,error,dispatch} = useContext(AuthContext)
  const handleClick = (e) => {
    
    e.preventDefault();
    try{
    loginCall({email:email.current.value,password:password.current.value},dispatch)

    }catch(e){

    prompt("TRY AGAIN");
    }
  };

	return (
		<div className="login">
      <div className="loginWrapper">
        <div className="loginLeft">
          <h3 className="loginLogo">Vyavhar</h3>
          <span className="loginDesc">
            The MayaWorld is Cruel Yaar...
          </span>
        </div>
        <div className="loginRight">
          <form className="loginBox" onSubmit={handleClick}>
            <input placeholder="Email" type='email' ref={email}  required className="loginInput" />
            <input placeholder="Password" type='password' ref={password} minLength='5' required className="loginInput" />
            <button className="loginButton" type="submit">Log In</button>
            <span className="loginForgot">Forgot Password?</span>
          </form>
          <Link to="/register"  >
            <button className="loginRegisterButtonl">
              Create a New Account
            </button>
          </Link>
        </div>
      </div>
    </div>
	)
}